import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { useLanguage, API } from '@/App';

const DEFAULT_CONTACT = {
  address: 'Fatih Mah, 1197. Sk. No:2/1, Sarnıç, Gaziemir/İzmir',
  phone: '+90 232 433 1 435',
  email: 'info@enerotomasyon.com.tr',
};

const Footer = () => {
  const { language } = useLanguage();
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/site-settings`)
      .then((res) => {
        if (!cancelled) setSiteSettings(res.data);
      })
      .catch((err) => console.error('Error fetching site settings:', err));
    return () => {
      cancelled = true;
    };
  }, []);

  const contactInfo = siteSettings?.contact_info?.[language] || {};
  const address = contactInfo.address || DEFAULT_CONTACT.address;
  const phone = contactInfo.phone || DEFAULT_CONTACT.phone;
  const email = contactInfo.email || DEFAULT_CONTACT.email;

  const content = {
    tr: {
      company: 'Şirket',
      about: 'Hakkımızda',
      services: 'Hizmetlerimiz',
      projects: 'Referanslar',
      blog: 'Blog',
      contact: 'İletişim',
      contactInfo: 'İletişim Bilgileri',
      followUs: 'Bizi Takip Edin',
      rights: 'Tüm hakları saklıdır.',
      description: 'Endüstriyel otomasyon ve elektrik sistemleri konusunda uzman çözümler sunuyoruz.',
    },
    en: {
      company: 'Company',
      about: 'About',
      services: 'Services',
      projects: 'References',
      blog: 'Blog',
      contact: 'Contact',
      contactInfo: 'Contact Information',
      followUs: 'Follow Us',
      rights: 'All rights reserved.',
      description: 'Expert solutions in industrial automation and electrical systems.',
    },
  };

  const t = content[language];

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img src="/ener-logo.png" alt="Ener Otomasyon" className="h-12 w-auto" />
            </div>
            <p className="text-gray-400 mb-4">
              {t.description}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-500 transition-colors" data-testid="social-facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-500 transition-colors" data-testid="social-twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-500 transition-colors" data-testid="social-linkedin">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-500 transition-colors" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.company}</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="hover:text-blue-500 transition-colors" data-testid="footer-about">{t.about}</Link></li>
              <li><Link to="/services" className="hover:text-blue-500 transition-colors" data-testid="footer-services">{t.services}</Link></li>
              <li><Link to="/projects" className="hover:text-blue-500 transition-colors" data-testid="footer-projects">{t.projects}</Link></li>
              <li><Link to="/blog" className="hover:text-blue-500 transition-colors" data-testid="footer-blog">{t.blog}</Link></li>
              <li><Link to="/contact" className="hover:text-blue-500 transition-colors" data-testid="footer-contact">{t.contact}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.contactInfo}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-500 mt-0.5" />
                <span className="text-sm">{address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-blue-500" />
                <span className="text-sm">{phone}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-blue-500" />
                <span className="text-sm">{email}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>© {new Date().getFullYear()} Ener Otomasyon Elektrik San. Tic. Ltd. Şti. {t.rights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;